import Auth from 'auth/AppAuthRoutes'
import Dashboard from 'dashboard/AppDashboardRoutes'
import Transactions from 'transactions/AppTransactionsRoutes'
import Points from 'points/AppPointsRoutes'
import Allies from 'allies/AppAlliesRoutes'
import Referrals from 'referrals/AppReferralsRoutes'
import Payments from 'payments/AppPaymentsRoutes'
import Users from 'users/AppUsersRoutes'
import Cards from 'cards/AppCardsRoutes'
import Activity from 'activity/AppActivityRoutes'
import Company from 'company/AppCompanyRoutes'
import DigitalAccountPayments from 'digital_account_payments/AppDigitalAccountPaymentsRoutes'
import Services from 'services/AppServicesRoutes'
import InternationalPayments from 'international_payments/AppInternationalPaymentsRoutes'
import Invoices from 'invoices/AppInvoicesRoutes'
import Reimbursements from 'reimbursements/AppReimbursementsRoutes'
import HelpCenter from 'help_center/AppHelpCenterRoutes'
import ApprovalsFlow from 'approvals_flow/AppApprovalsFlowRoutes'
import Tasks from 'tasks/AppTasksRoutes'
import ExpensesPoliciesSettings from 'expenses_policies_settings/AppExpensesPoliciesSettingsRoutes'

const routes = [].concat.apply(
  [],
  [
    Auth,
    Dashboard,
    Transactions,
    Points,
    Allies,
    Referrals,
    Payments,
    Users,
    Cards,
    Activity,
    Company,
    DigitalAccountPayments,
    Services,
    InternationalPayments,
    Invoices,
    Reimbursements,
    HelpCenter,
    ApprovalsFlow,
    Tasks,
    ExpensesPoliciesSettings,
  ],
)
export default routes
